<template lang="pug">
div.wrap-atom-look-at-changer.py12
  div.f.fc
    div(@click="onChanger").look-at-changer.cursor-pointer
      vue-draggable-resizable(
        w="auto" h="auto" :x="x" :y="y"
        :resizable="false"
        :min-width="10" :min-height="10"
        @dragging="setEyesBone")
        div(@click.stop).drag-point
      div.wrap-border
        div.border-1
        div.border-2
      //- div.wrap-border
        div.border1
        div.border2
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
$changer_size: 240px;
$drag_point_size: 20px;
$border: dashed 0.1px rgba(255, 255, 255, 0.4);
.wrap-atom-look-at-changer {
  .look-at-changer {
    position: relative;
    width: $changer_size; height: $changer_size;
    background: $overlay_color;
    border: rgba(0, 0, 0, 0.1);
    .drag-point {
      width: $drag_point_size; height: $drag_point_size;
      border: solid 2px $active_color;
      border-radius: 50%;
      box-shadow: $box_shadow;
      background: $overlay_color;
    }
    .wrap-border {
      .border-1 {
        position: absolute;
        top: 0; left: 50%;
        width: 1px; height: 100%;
        border: $border;
      }
      .border-2 {
        position: absolute;
        z-index: 0;
        top: 50%; left: 0;
        width: 100%; height: 1px;
        border: $border;
      }
    }
  }
}
</style>

<script>
import vrmManager from '@/components/mixin/vrmManager'
import VueDraggableResizable from 'vue-draggable-resizable'

export default {
  mixins: [vrmManager],
  components: {
    VueDraggableResizable
  },
  props: {
    currentLeftEyeBone: {
      type: Object,
      required: true
    },
    currentRightEyeBone: {
      type: Object,
      required: true
    },
    targetObject: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      x: 0, y: 0,
      centerPos: { x: 240 / 2, y: 240 / 2 },
      pointSize: 20,
      offset: 240 * 1.5
    }
  },
  async created () {
    const rotation = this.currentLeftEyeBone.rotation
    this.x = rotation.y * this.offset + this.centerPos.x - this.pointSize/2
    this.y = -rotation.x * this.offset + this.centerPos.y - this.pointSize/2
  },
  methods: {
    setEyesBone (x, y) {
      let rotationX = -(y - this.centerPos.y + this.pointSize/2) / this.offset
      let rotationY = (x - this.centerPos.x + this.pointSize/2) / this.offset
      // vrm1.0はデフォルトで半回転しているので左右が逆になる
      if (this.isVRM1({ vrm: this.targetObject.userData.vrm })) {
        rotationY *= -1
      }
      this.$emit('updateEyesBone', { 
        x: Math.round(rotationX * 100) / 100, // 小数点100位以下切り捨て
        y: Math.round(rotationY * 100) / 100 // 小数点100位以下切り捨て
      })
    },
    onChanger (e) {
      this.x = e.offsetX
      this.y = e.offsetY
      this.setEyesBone(this.x, this.y)
    }
  }
}
</script>
